var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonwloadFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_44444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66624 16.3494L4.58984 16.4258L4.88452 20.4858H19.7822L20.0878 16.3494H4.66624Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0769 7.57443L19.7822 3.5144H4.88452L4.58984 7.65083H20.0114L20.0769 7.57443Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 23.5635C11.4353 20.7961 10.0734 18.2543 8.08226 16.251C6.08045 14.2638 3.54338 12.9024 0.780762 12.3329V11.6671C3.54491 11.1019 6.08312 9.73984 8.08226 7.74901C10.0731 5.74987 11.4352 3.21165 12.0004 0.44751H12.6662C13.2356 3.21013 14.5971 5.74719 16.5843 7.74901C18.5876 9.74015 21.1293 11.1021 23.8967 11.6671V12.3329C21.1266 12.8903 18.5828 14.2535 16.5848 16.2516C14.5868 18.2496 13.2235 20.7933 12.6662 23.5635H12.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61157 16.4146L17.0536 3.97261L19.0618 3.92896L20.0659 7.59608L7.80939 19.8526L5.68115 20.1363L4.61157 16.4146Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3442 11.307C21.5303 10.8013 18.9376 9.44971 16.9117 7.43247C14.8876 5.41164 13.5348 2.81658 13.0372 0L11.6402 0C11.1372 2.81475 9.78523 5.40827 7.76572 7.43247C5.74152 9.45198 3.148 10.804 0.333252 11.307L0.333252 12.704C3.14853 13.1985 5.74344 14.5474 7.76572 16.5675C9.78491 18.5963 11.1367 21.1932 11.6402 24.0109H13.0372C13.5292 21.1917 14.8791 18.593 16.9027 16.5695C18.9263 14.5459 21.525 13.196 24.3442 12.704V11.307ZM16.2896 15.9454C14.3362 17.8819 12.967 20.3289 12.3387 23.0068C11.7085 20.3321 10.344 17.8864 8.39874 15.9454C6.45508 13.998 4.0053 12.6332 1.32643 12.0055C4.00361 11.3734 6.45227 10.0092 8.39874 8.06549C10.3425 6.11902 11.7066 3.67036 12.3387 0.993179C12.9665 3.67205 14.3312 6.12183 16.2787 8.06549C18.2197 10.0107 20.6653 11.3753 23.3401 12.0055C20.6634 12.6307 18.2165 13.996 16.2787 15.9454H16.2896Z",
    fill: "#4611A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_44444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonwloadFilledIcon);
export default __webpack_public_path__ + "static/media/donwload-filled-icon.bbc87be321cd7f42003d0ca2e4482b6b.svg";
export { ForwardRef as ReactComponent };